import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AlarisAuthService } from '@campaign-portal/components-library';

@Injectable({
	providedIn: 'root',
})
export class DropAuthGuardService {
	constructor(private readonly authService: AlarisAuthService) {}

	canActivate(): boolean {
		this.authService.resetAuth();
		return true;
	}
}

export const DropAuthGuard: CanActivateFn = (): boolean => inject(DropAuthGuardService).canActivate();
